// Manda la foto o captura de un pago a /api/leer-captura y devuelve lo que leyó la IA.
// Las fotos se achican antes de subirlas: una foto de celular pesa varios MB y la IA lee igual
// de bien una de 1600 px. El archivo original es el que se guarda como comprobante.
import { supabase } from '../supabaseClient';
import { hoyISO } from './format';

const LADO_MAXIMO = 1600;

const leerComoBase64 = (blob) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(String(r.result).split(',')[1] || '');
  r.onerror = () => reject(new Error('No se pudo leer el archivo'));
  r.readAsDataURL(blob);
});

async function achicarImagen(file) {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error('No se pudo abrir la imagen'));
      i.src = url;
    });
    const escala = Math.min(1, LADO_MAXIMO / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.width * escala);
    canvas.height = Math.round(img.height * escala);
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff'; // las capturas PNG con fondo transparente se leen mejor sobre blanco
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85));
    return { datos: await leerComoBase64(blob), tipo: 'image/jpeg' };
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function leerCaptura(file, presupuestos = []) {
  const esPdf = file.type === 'application/pdf';
  if (!esPdf && !file.type.startsWith('image/')) throw new Error('Sube una foto, captura o PDF.');

  const [{ datos, tipo }, { data: { session } }] = await Promise.all([
    esPdf ? leerComoBase64(file).then(d => ({ datos: d, tipo: 'application/pdf' })) : achicarImagen(file),
    supabase.auth.getSession(),
  ]);

  const res = await fetch('/api/leer-captura', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session?.access_token || ''}`,
    },
    body: JSON.stringify({ datos, tipo, hoy: hoyISO(), presupuestos }),
  });
  // Si la ruta no existe, Cloudflare devuelve el index.html: avisarlo claro en vez de "JSON inválido"
  const texto = await res.text();
  let r;
  try { r = JSON.parse(texto); } catch { throw new Error('El lector de capturas no respondió. Complétalo a mano.'); }
  if (!res.ok) throw new Error(r.error || `Error ${res.status}`);
  return r;
}
